// Copyright (c) 2017 TrainHeroic LLC
// Table tree is used to manage the state of all of the rTables / lists
import { normalize } from 'normalizr';
import { getStore } from '../../store';
import ACTIONS from './actions';
import * as ProgramService from '../../../api/service/programService';
import { workoutSummarySchema } from '../workout/schema';

export const addAthleteCalendarSummary = data => {
    const payload = normalize(data, [workoutSummarySchema]);
    getStore().dispatch({
        type: ACTIONS.SUMMARY_ADD_ATHLETE_SUMMARY,
        payload
    });
};

export const getAthleteSummaryForProgramWorkout = async (
    workoutId,
    athleteId,
    session
) => {
    const summaryFeedProgram = await ProgramService.getAthleteSummaryForProgramWorkout(
        workoutId,
        athleteId
    );
    getStore().dispatch({
        type: ACTIONS.FEED_SUMMARY_LOAD,
        summaryFeedProgram,
        session
    });
};

export const loadAthleteCalendarSummary = data => {
    const payload = normalize(data, [workoutSummarySchema]);

    getStore().dispatch({
        type: ACTIONS.CALENDAR_LOAD_ATHLETE_SUMMARY,
        payload
    });
};

export const loadTeamCalendarSummary = data => {
    const payload = data;
    getStore().dispatch({
        type: ACTIONS.CALENDAR_LOAD_TEAM_SUMMARY,
        payload
    });
};



// WEBPACK FOOTER //
// ./src/state/reducer/summary/summary.js